import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  noBankContainer: {
    textAlign: "center",
    padding: "20px 0"
  },
  addAccountLink: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    marginTop: "10px"
  },
  withdrawalContainer: {
    marginBottom: "20px",
    marginTop: "10px"
  },
  bankOption: {
    border: "1px solid #E0E0E0",
    borderRadius: "8px",
    padding: "15px",
    marginBottom: "10px",
    display: "flex",
    alignItems: "center"
  },
  bankOptionSelected: {
    border: "1px solid #E0E0E0",
    borderRadius: "8px",
    padding: "15px",
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  radioInput: {
    marginRight: "15px",
    width: "18px",
    height: "18px"
  },
  bankDetails: {
    "& .bankName": {
      fontWeight: 600
    },
    "& .accountNumber": {
      color: "#888",
      fontSize: "0.9rem"
    }
  },
  editIcon: {
    color: "#888",
    cursor: "pointer"
  },
  actionButtons: {
    display: "flex",
    gap: "15px"
  },
  flexGap10: {
    display: "flex",
    gap: "10px"
  },
  transactionHistory: {
    backgroundColor: "white",
    padding: "1rem",
    borderRadius: "8px"
  },
  historyTitle: {
    marginBottom: "1rem",
    fontWeight: 600
  },
  marginTop20: {
    marginTop: "20px"
  },
  marginBottom2rem: {
    marginBottom: "2rem"
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "20px"
  },
  inputPickerTitle: {
    color: "#101928",
    marginBottom: "4px",
    fontSize: "14px",
    fontWeight: 500,
    marginTop: "5px",
    textAlign: "left"
  },
  inputRequired: {
    color: "red",
    marginLeft: "2px"
  },
  accord_body: {
    borderRadius: "16px",
    padding: "15px 20px",
    border: "1px solid #E4E7EC",
    backgroundColor: "white",
    marginTop: "10px"
  },
  accord_body_primary: {
    border: `2px solid ${theme.palette.primary.main}`
  },
  bank_currency: {
    margin: 0,
    padding: "2px 8px",
    borderRadius: "50%",
    background: theme.palette.primary.main,
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
    minWidth: "24px",
    height: "24px",
    fontSize: "12px"
  },
  account_details: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: 0,
    "& strong": {
      marginBottom: "4px",
      fontSize: "14px",
      color: "#101928"
    }
  },
  span: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#98A2B3"
  },
  Icon: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    color: theme.palette.primary.main,
    fontSize: "14px",
    justifyContent: "flex-start",
    cursor: "pointer",
    fontWeight: 500
  },
  bankingheader: {
    marginBottom: "10px",
    "& h4": {
      marginBlock: "0px",
      textAlign: "left",
      marginBottom: "4px",
      fontSize: "16px",
      fontWeight: 500
    },
    "& h6": {
      marginBlock: "0px",
      textAlign: "left",
      fontWeight: 400,
      fontSize: "14px",
      color: "#667185",
      marginBottom: "20px"
    }
  }
}));
